import type { IMasterDataProductUomRepository } from "@src/domain/repositories/masterData";
import type { UpdateMasterDataProductUomDTO } from "@src/domain/dto/masterData";

export class UpdateMasterDataProductUomUseCase {
  private readonly repository: IMasterDataProductUomRepository;

  constructor(repository: IMasterDataProductUomRepository) {
    this.repository = repository;
  }

  execute(params: UpdateMasterDataProductUomDTO) {
    return this.repository.updateProductUom(params);
  }
}
